<template>
  <div>
    <div class="legend-container">
      <div class="legend" v-for="(series, index) in options.series.reverse()"
        :key="index">
        <div class="legend-color" :style="{ backgroundColor: series.color }">
        </div>
        <span class="legend-text">{{series.name}}</span>
      </div>
    </div>
    <VueHighcharts :options="options" ref="lineCharts"></VueHighcharts>
  </div>
</template>

<script>
/* eslint-disable */
import VueHighcharts from 'vue2-highcharts';

const asyncData = {
  name: '',
  data: [7.0, 6.9, 9.5, 14.5],
};
export default {
  props: {
    series: {
      type: Object,
    },
  },
  components: {
    VueHighcharts,
  },
  mounted() {
    const lineCharts = this.$refs.lineCharts;
    // lineCharts.addSeries(asyncData);
    // lineCharts.hideLoading();
  },
  data() {
    return {
      // options:
    };
  },
  computed: {
    options() {
      return {
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
          width: 500,
          height: 400,
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['Truck In - Loading Start', 'Loading Start - End', 'Loading End - Dispatch'],
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: ''
          },
          labels: {
            formatter: function() {
               return this.value+"%";
            }
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color:  'gray'
            }
          }
        },
        legend: {
          align: 'right',
          // x: -30,
          verticalAlign: 'top',
          y: -50,
          floating: true,
          backgroundColor: 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          // pointFormat: '{series.name}: {point.y}%<br/>Compliance: {point.real} Intents',
          pointFormat: '{point.sla} <br/>Compliance: {point.real} Indents ({point.y}%)',

        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: 'white',
              format: '{y}%',
            },
          }
        },
        series: [{
          name: '< STD Time',
          data: this.series['< STD Time'],
          color: '#B8E986',
        }, {
          name: '< 1.2 STD Time',
          data: this.series['< 1.2 STD Time'],
          color: '#FFE789',
        }, {
          name: '> 1.2 STD Time',
          data: this.series['> 1.2 STD Time'],
          color: '#E37161',
        }].reverse()
      };
    },
  },
};
</script>
<style lang="scss" scoped>
  .highcharts-root {
      display: block;
  }
  .legend-container {
    float: right;
  }
  .legend {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
  }
  .legend-color {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: #B8E986;
    border-radius: 5px;
  }
  .legend-text {
    color: #6D8EB4;
    font-size: 11px;
    line-height: 13px;
  }
</style>
